import styled from "styled-components"

export const PictureBanner = styled.section`
  position: relative;
  background-position: center;
  max-height: 400px;
  width: 100%;
  margin: 0 auto;
  background-color: transparent;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

export const BannerImageBig = styled.img`
  display: none;
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media (min-width: 900px) {
    display: block;
  }
`

export const BannerImageSmall = styled.img`
  width: 100%;
  @media (min-width: 900px) {
    display: none;
  }
`
